export default __webpack_public_path__ + "static/media/blog4.26cbeb98.png";